import { Card, Icon } from '@zillow/constellation-10';
import { IconChecklistFilled } from '@zillow/constellation-icons';

import EmptyState from '../../../EmptyState';

type Props = {
  title: string;
  description: string;
  actionUrl: string;
  actionText: string;
};

const EmptyPropertyConditionModule = ({ title, description, actionUrl, actionText }: Props) => {
  return (
    <Card
      data-testid="EmptyPropertyConditionModule"
      tone="neutral"
      elevated={false}
      css={{ paddingInline: 'looser', paddingBlock: 'loosest' }}
    >
      <EmptyState
        useCard={false}
        icon={<Icon size="md" css={{ color: 'icon.subtle' }} render={<IconChecklistFilled />} />}
        heading={title}
        body={description}
        primaryAction={{ label: actionText, href: actionUrl }}
      />
    </Card>
  );
};

export default EmptyPropertyConditionModule;
